import TmdbService from "../../services/tmdb";

export const FAVORITE_ITEM_LOADED = "FAVORITE_ITEM_LOADED";
export const FAVORITE_ITEM_ERROR = "FAVORITE_ITEM_LOADED";
export const FAVORITE_ITEM_REMOVE = "FAVORITE_ITEM_REMOVE";

const tmdb = new TmdbService();

export const favoriteLoaded = movies => {
  return {
    type: FAVORITE_ITEM_LOADED,
    payload: movies
  };
};

export const favoriteError = () => {
  return {
    type: FAVORITE_ITEM_ERROR
  };
};

export const favoriteRemove = id => {
  return {
    type: FAVORITE_ITEM_REMOVE,
    payload: id
  };
};

export const fetchFavoriteMovie = (dispatch, id) => {
  tmdb
    .getDetails(id)
    .then(data => dispatch(favoriteLoaded(data)))
    .catch(() => dispatch(favoriteError()));
};

export const removeFromFavorite = (dispatch, id) => {
  dispatch(favoriteRemove(id));
};
